import {IOccupationalStatusProps} from "@my-pages/features/employment/types";
import OccupationStatus from "@my-pages/features/employment/components/Occupation/OccupationStatus.tsx";


const PreviousOccupation = ({occupationStatus}: IOccupationalStatusProps) => {

    return (<div className="card border border-2 h-100">
        <div className="card-body">
            <div className="kicker mb-2">Föregående status</div>
            <OccupationStatus occupationStatus={occupationStatus}/>
        </div>
    </div>)
}

export default PreviousOccupation;